export class VcfMeasurementsError extends Error {
    constructor(m?: string) {
        if (!m) {
            m = 'Measurements data cannot be retrieved';
        }
        super(m);
    }
}